/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagVi: {
  name: 'flag_vi';
  data: string;
} = {
  name: 'flag_vi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#DA251D" d="M0 0h32v24H0V0Z"/><path fill="#FF0" d="m20.387 17.86-4.2-3.127-4.171 3.154 1.546-5.137-4.171-3.173 5.16-.047 1.604-5.128 1.626 5.114 5.161.004-4.148 3.207 1.589 5.137.005-.005Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
